import { NetworkType } from "@cardano-foundation/cardano-connect-with-wallet-core";

/**
 * Application configuration
 *
 * Network can be controlled via VITE_CARDANO_NETWORK environment variable:
 * - Set to "testnet" for testnet (Preview network)
 * - Set to "mainnet" for mainnet
 * - Defaults to mainnet if not set
 *
 * Usage in components:
 * import { CARDANO_NETWORK } from "@constants/config";
 * const { ... } = useCardano({ limitNetwork: CARDANO_NETWORK });
 */

const getCardanoNetwork = (): NetworkType => {
  const envNetwork = import.meta.env.VITE_CARDANO_NETWORK?.toLowerCase();

  if (envNetwork === "testnet") {
    return NetworkType.TESTNET;
  }

  // Default to mainnet
  return NetworkType.MAINNET;
};

export const CARDANO_NETWORK = getCardanoNetwork();

// Log network on app startup (only in development)
if (import.meta.env.DEV) {
  console.log(`[Config] Cardano Network: ${CARDANO_NETWORK === NetworkType.MAINNET ? 'MAINNET' : 'TESTNET'}`);
}
